import { useQuery } from "@tanstack/react-query";

import { getSubscriberLevel0Resource } from "@services/subscriber";

export const useSubscriberLevel0Resource = ({
  params,
  ...options
}: {
  params: {
    level0ResourceId: string;
  };
  [key: string]: any;
}) => {
  return useQuery<any>({
    queryKey: ["subscriberLevel0Resource", params],
    queryFn: () => getSubscriberLevel0Resource(params),
    enabled: Boolean(params.level0ResourceId),
    ...options,
  });
};
